import React, { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "@/store/hooks";
import {
  removeNotification,
  selectNotifications,
} from "@/store/slices/uiSlice";

const AUTO_DISMISS_MS = 6000;

function GlobalNotifications() {
  const dispatch = useAppDispatch();
  const notifications = useAppSelector(selectNotifications);

  useEffect(() => {
    const timers = notifications.map((notification) => {
      const elapsed = Date.now() - notification.timestamp;
      const remaining = Math.max(0, AUTO_DISMISS_MS - elapsed);

      return window.setTimeout(() => {
        dispatch(removeNotification(notification.id));
      }, remaining);
    });

    return () => {
      timers.forEach((timer) => window.clearTimeout(timer));
    };
  }, [dispatch, notifications]);

  if (notifications.length === 0) {
    return null;
  }

  return (
    <div className="globalNotifications" aria-live="polite" aria-relevant="additions">
      {notifications.map((notification) => (
        <div
          key={notification.id}
          className={`globalNotification globalNotification-${notification.type}`}
          role={notification.type === "error" ? "alert" : "status"}
        >
          <div className="globalNotificationText">{notification.message}</div>
          <button
            type="button"
            className="globalNotificationClose"
            aria-label="Close notification"
            onClick={() => dispatch(removeNotification(notification.id))}
          >
            x
          </button>
        </div>
      ))}
    </div>
  );
}

export default GlobalNotifications;
